import script from "./z-loading.vue?vue&type=script&setup=true&lang=js"
export * from "./z-loading.vue?vue&type=script&setup=true&lang=js"

import "./z-loading.vue?vue&type=style&index=0&id=2d75b3d8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d75b3d8"]])

export default __exports__